const getMeta = ({ size, total_size, total_page, page }: Paging) => {
  const separator = page * size
  
  return {
    startItem: separator + 1,
    endItem: page + 1 === total_page ? total_size : (separator + 1) * size,
    totalItem: total_size,
    lastPage: total_page,
    pageNumber: page + 1,
  }
}

const getMeta2 = ({ size, total_size, total_page, page }: Paging) => {
  const output = {} as any;
  
  output.page = page;
  output.startItem = total_size === 0 ? 0 : (page * size) + 1;
  output.endItem = (page + 1) * size > total_size ? total_size : (page + 1) * size;
  output.totalItem = total_size;
  output.lastPage = total_page === 0 ? 0 : total_page - 1;
  
  return output;
}

const defaultMeta = {
  startItem: 0,
  endItem: 0,
  totalItem: 0,
  lastPage: 0,
  pageNumber: 1,
}

export const constructTableMetaFromPaging = (paging: Paging) => paging
  ? getMeta(paging)
  : defaultMeta

export const constructTableMetaFromPaging2 = (paging: Paging) => paging
  ? getMeta2(paging)
  : defaultMeta